var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { AbstractMeasurementDataClient, } from "../MeasurementDataClient";
import SignalViewerDataClientWorker from "./SignalViewerDataClient.worker";
let signalViewerDataClientWorker;
/**
 * Implementation of MeasurementDataClient for the online environment.
 *
 * This either uses websockets for HDF5 files, or sends HTTP requests to the SBF server depending on which files we're
 * retrieving for.
 *
 * SBF files are considered legacy, and there is no support for retrieving measurement data using websockets.
 */
export class SignalViewerDataClient extends AbstractMeasurementDataClient {
    constructor({ hdfEndpoint, sbfEndpoint }) {
        super();
        this.cId = 0;
        this.promises = [];
        this.fetchMetadata = (file) => __awaiter(this, void 0, void 0, function* () {
            const id = this.nextId();
            let res = () => { };
            let rej = () => { };
            // Create promise around worker call
            const p = new Promise((resolve, reject) => {
                signalViewerDataClientWorker.postMessage({
                    func: "fetchMetadata",
                    id: id,
                    args: [file],
                });
                res = resolve;
                rej = reject;
            });
            this.promises[id] = { promise: p, resolve: res, reject: rej };
            // wait till worker returns with the response
            return yield this.promises[id].promise;
        });
        this.fetchMeasurementData = (args) => __awaiter(this, void 0, void 0, function* () {
            const id = this.nextId();
            let res = () => { };
            let rej = () => { };
            const convertedArgs = Object.assign(Object.assign({}, args), { measurements: args.measurements.map((m) => {
                    // when requesting a single result we can pass an epsilon of 0
                    if (args.rows !== undefined && args.rows === 1) {
                        return {
                            name: m.index.join("/"),
                            n_out: null,
                        };
                    }
                    const secondMicroSecond = 1000000;
                    // If the amount of points visible for the selected amount of time is smaller than 250, we want them all
                    if (args.limit !== undefined &&
                        m.frequency * (args.limit / 4 / secondMicroSecond) < 250) {
                        return {
                            name: m.index.join("/"),
                            n_out: null,
                        };
                    }
                    return {
                        name: m.index.join("/"),
                        n_out: args.rows,
                    };
                }), output_format: "PLOTLY", algorithm: "TSD" });
            // Create promise around worker call
            const p = new Promise((resolve, reject) => {
                signalViewerDataClientWorker.postMessage({
                    func: "fetchMeasurementData",
                    id: id,
                    args: [convertedArgs],
                });
                res = resolve;
                rej = reject;
            });
            this.promises[id] = { promise: p, resolve: res, reject: rej };
            // wait till worker returns with the response
            return yield this.promises[id].promise;
        });
        this.fetchOverlayData = (args) => __awaiter(this, void 0, void 0, function* () {
            const id = this.nextId();
            let res = () => { };
            let rej = () => { };
            // Create promise around worker call
            const p = new Promise((resolve, reject) => {
                signalViewerDataClientWorker.postMessage({
                    func: "fetchOverlayData",
                    id: id,
                    args: [args],
                });
                res = resolve;
                rej = reject;
            });
            this.promises[id] = { promise: p, resolve: res, reject: rej };
            // wait till worker returns with the response
            return yield this.promises[id].promise;
        });
        this.fetchReqData = (args) => __awaiter(this, void 0, void 0, function* () {
            const id = this.nextId();
            let res = () => { };
            let rej = () => { };
            // Create promise around worker call
            const p = new Promise((resolve, reject) => {
                signalViewerDataClientWorker.postMessage({
                    func: "fetchReqData",
                    id: id,
                    args: [args],
                });
                res = resolve;
                rej = reject;
            });
            this.promises[id] = { promise: p, resolve: res, reject: rej };
            // wait till worker returns with the response
            return yield this.promises[id].promise;
        });
        this.hdfEndpoint = hdfEndpoint;
        this.sbfEndpoint = sbfEndpoint;
        // initialize worker class
        signalViewerDataClientWorker = new SignalViewerDataClientWorker({
            hdfEndpoint,
            sbfEndpoint,
        });
        signalViewerDataClientWorker.onmessage = (event) => {
            // For now only return the response code on the fetchMetadata request of a file
            // an incorrect h5m will fail here
            if (event.data.func === "fetchMetadata") {
                this.promises[event.data.id].resolve({
                    response: event.data.response,
                    code: event.data.code,
                });
            }
            else {
                this.promises[event.data.id].resolve(event.data.response);
            }
        };
        // first "constructor" message to worker
        signalViewerDataClientWorker.postMessage({
            func: "constructor",
            id: this.cId,
            args: [this.hdfEndpoint, this.sbfEndpoint],
        });
    }
    /**
     * Returns a number and increments the cId. Used for "tagging" requests to the endpoint so we can recognise matching response.
     * @returns number
     */
    nextId() {
        let nextId = this.cId + 1;
        this.cId = nextId;
        return nextId;
    }
    destroy() {
        signalViewerDataClientWorker.postMessage({
            func: "destroy",
            id: 0,
            args: [],
        });
    }
}
//# sourceMappingURL=SignalViewerDataClient.js.map